module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/profile_page/society-30eeaa693547dff16744d72f3dfc860e.png";